import { useRouter } from "next/router";
import { Box, styled, Typography } from "@mui/material";

import {
  convertCourseType,
  convertLevelText,
} from "@shared/lib/utils/classData";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { CourseTypeEnum, DifficultyEnum } from "@shared/generated/api/model";

interface CourseTitleSectionProps {
  type: CourseTypeEnum;
  difficulty: DifficultyEnum;
  title: string;
  scheduleId: number;
  size?: "small" | "medium";
}

export const CourseTitleSection = ({
  type,
  difficulty,
  title,
  scheduleId,
  size = "medium",
}: CourseTitleSectionProps) => {
  const { t } = useCustomTranslation();
  const router = useRouter();

  const handleClick = () => {
    router.push(`/my/schedule/${scheduleId}`);
  };

  return (
    <Container>
      <MetaText size={size}>
        {`${t(convertCourseType(type))}`} |{" "}
        {`${t(convertLevelText(difficulty))}`}
      </MetaText>
      <TitleText
        size={size}
        onClick={handleClick}
      >
        {title}
      </TitleText>
    </Container>
  );
};


const Container = styled(Box)({
  height: 62,
});

const MetaText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "size",
})<{ size?: "small" | "medium" }>(({ theme, size = "medium" }) => ({
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center",
  color: theme.palette?.text?.secondary,
  fontSize: "12px",
}));

const TitleText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "size",
})<{ size?: "small" | "medium" }>(({ size = "medium" }) => ({
  position: "relative",
  fontWeight: 700,
  fontSize: "14px",
  letterSpacing: "-0.4px",
  color: "#333333",
  textAlign: "left",
  textDecoration: "underline",
  textDecorationStyle: "solid",
  textUnderlinePosition: "from-font",
  textDecorationSkipInk: "none",
  lineHeight: "20px",
  cursor: "pointer",
  "&:hover": {
    color: "#000000",
  },
}));
